import axios from 'axios';

const instance = axios.create({
  // baseURL: "https://klazjadjh1.execute-api.us-east-2.amazonaws.com/v0/"
  baseURL: "https://klbv8hqfgl.execute-api.us-east-2.amazonaws.com/v0/",
});

export default instance;